import { render, staticRenderFns } from "./SerieForm.vue?vue&type=template&id=5e3eddbf&"
import script from "./SerieForm.vue?vue&type=script&lang=js&"
export * from "./SerieForm.vue?vue&type=script&lang=js&"
import style0 from "./SerieForm.vue?vue&type=style&index=0&id=5e3eddbf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports